var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25741 0H24.7603C25.9738 0 27.0201 1.04629 27.0201 2.25741V24.7615C27.0201 25.975 25.9738 27.0201 24.7615 27.0201H2.25741C1.04629 27.0201 0 25.975 0 24.7615V2.25741C0 1.04629 1.04629 0 2.25741 0ZM22.7736 9.28125C22.5156 8.32617 21.7676 7.57227 20.8184 7.31836C19.0957 6.85547 13.5 6.85547 13.5 6.85547C13.5 6.85547 7.90625 6.85547 6.18164 7.31836C5.23047 7.57227 4.48438 8.32617 4.22656 9.28125C3.76758 11.0059 3.76758 14.5957 3.76758 14.5957C3.76758 14.5957 3.76758 18.1875 4.22656 19.9102C4.48438 20.8652 5.23047 21.6191 6.18164 21.873C7.90625 22.334 13.5 22.334 13.5 22.334C13.5 22.334 19.0957 22.334 20.8184 21.873C21.7676 21.6191 22.5156 20.8652 22.7736 19.9102C23.2305 18.1875 23.2305 14.5957 23.2305 14.5957C23.2305 14.5957 23.2305 11.0059 22.7736 9.28125ZM11.6484 17.9941V11.1973L17.1582 14.5957L11.6484 17.9941Z",
    fill: "#002E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.31aa23e8becbcc0e058af7b1fd15f9d6.svg";
export { ForwardRef as ReactComponent };